import React, {useState, useEffect, useReducer} from "react";
import moment from "moment";
import "moment/locale/en-gb";
import "moment/locale/es";
import Linkify from "react-linkify";
import extractUrls from "extract-urls";
import {v1 as uuidv1} from "uuid";
import {ReactTinyLink} from 'react-tiny-link'
import {Avatar} from "antd";
import Microlink from "@microlink/react";
import {FolderAddOutlined, MoreOutlined, SendOutlined, ShareAltOutlined} from "@ant-design/icons";

const MessageTutor = (props) => {
    const {item, t, user} = props;
    const [linksPreview, setLinksPreview] = useState([]);

    useEffect(() => {

        let urls = extractUrls(item.comment);

       // mountLinks(urls);

    }, []);
    const showDiff = (date) => {

        var duration = moment().diff(moment(date), 'days');

        if (moment(moment(date).format("YYYY-MM-DD")).isSame(moment().format("YYYY-MM-DD"))) {
            return moment(date).format("HH:mm")
        } else {
            if (duration < 5) {
                if (duration === 0) {
                    duration = 1;
                }
                return t("hace") + " " + duration + " " + (duration == 1 ? t("day") : t("days"));
            } else {
                return moment(date).format("DD/MM/YYYY hh:mm")
            }

        }
        return moment(date).format("DD/MM/YYYY hh:mm")
    }


    const mountLinks = async (urls) => {

        let mTempLinks = [];

        if (urls && urls.length > 0) {
            await Promise.all(
                urls.map(async (url) =>
                    {
                        fetch(url).then(response => {
                            response.text().then(data => {
                                const parser = new DOMParser();
                                const doc = parser.parseFromString(data, 'text/html');
                                const title = doc.querySelector('title')?.textContent || '';
                                const description = doc.querySelector('meta[name="description"]')?.getAttribute('content') || '';
                                const image = doc.querySelector('meta[property="og:image"]')?.getAttribute('content') || '';

                            })
                        })


                    }
                    /*fetch("https://api.peekalink.io/", {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            "X-API-Key": "7f7cb01d-13ba-44b4-978d-495eef10a3a4"
                        },
                        body: JSON.stringify({"link": url}),
                    }).then((response) => response.json())*/
                )
            )
                .then((res) => {
                    if (res && res[0]) mTempLinks.push(res[0]);
                })
                .catch((err) => {
                    console.error("Failed to fetch one or more of these URLs:");
                });
        }
        setLinksPreview(mTempLinks);
    };

    const showText = (text) => {


        return (async () => {
            let urls = extractUrls(text);
            let urlsParsed = [];
            if (urls && urls.length > 0) {
                mountLinks(urls).then(res => urlsParsed = res);
            }
            return <>
                <Linkify key={uuidv1()} componentDecorator={componentDecorator}>{text}</Linkify>
                {urls && urls.length > 0 && urls.map(url =>
                    (

                        <ReactTinyLink
                            cardSize="small"
                            showGraphic={true}
                            maxLine={2}
                            minLine={1}
                            url={url}
                        />
                    )
                )}
            </>
        })


    }

    const componentDecorator = (href, text, key) => (
        <Microlink url={href} />

    );


    const getName = (item) => {

        if (item.sendByMaster){
            return "Admin"
        }else{
            if (item.sendByCenter){
                return item.center?.name;
            }else{
                if (item.sendByStudent) {
                    return item.student?.name + " " + item.student?.surname;
                }
                if (item.sendByOrientador){
                    if (item.orientadores)
                        return item.orientadores?.name + " " + item.orientadores?.surname;
                    else
                        return item.tutor?.name + " " + item.tutor?.surname;
                }else {
                    if (item.sendByTutor){
                        if (item.tutores) {
                            return item.tutores?.name + " " + item.tutores?.surname;
                        }
                    }else {
                        if (item.orientador_id) {
                            if (item.orientadores)
                                return item.orientadores?.name + " " + item.orientadores?.surname;
                            else
                                return item.tutor?.name + " " + item.tutor?.surname;
                        } else {
                            if (item.tutores) {
                                return item.tutores?.name + " " + item.tutores?.surname;
                            }
                        }
                    }

                    return item.tutor?.name + " " + item.tutor?.surname;
                }
            }
        }

    }



    const getRole = (item) => {


        if (item.sendByMaster){
            return "Master Orion"
        }else{
            if (item.sendByCenter){
                return t("isCenterE");
            }else{
                if (item.sendByStudent) {
                    return t("isStudent")
                }
                if (item.sendByOrientador){
                    return t("isOrientador")
                }else {
                    if (item.sendByTutor){
                        if (item.tutores) {
                            return t("isTutor")
                        }
                    }else {
                        if (item.orientador_id) {
                            if (item.orientadores)
                                return t("isOrientador")
                            else
                                return t("isTutor")
                        } else {
                            if (item.tutores) {
                                return t("isTutor")
                            }
                        }
                    }

                }

                return t("isTutor")

            }
        }

    }



    return (
        <>
            <div className={"balloon-text"}>
                <div className={"balloon-info"}>
                    <div className={"balloon-info-top"}>
                        <div className={"name"}>
                            {getName(item)}

                        </div>
                        <div className={"data"}>{showDiff(item.createdAt)}</div>
                    </div>
                        <div className={"type"}>
                            {getRole(item)}
                        </div>
                    </div>
                <p><Linkify key={uuidv1()} componentDecorator={componentDecorator}>{item.comment}</Linkify></p>
            {linksPreview && linksPreview.length > 0 && linksPreview.map(url => {

                return <div key={uuidv1()} >
                    <div key={uuidv1()}  className={"card-resources-folders is-resources"}>
                        <img src={url.image && url.image.url ? url.image.url : "https://dummyimage.com/58x58/000/fff"} alt={""}  height={58}/>
                        <div className={"card-resources-folders__content"}>
                            <h3 className={"card-resources-folders__title"}>{url.title}</h3>
                            <p className={"card-resources-folders__description"}>{url.description}</p>
                            <a className={"card-resources-folders__link"} href={url.url} target={"_blank"}>{url.url}</a>
                        </div>
                        <div className={"card-resources-folders__menu"}>
                            <button className={"card-resources-folders__menu-btn"}><MoreOutlined /></button>
                            <div className="card-resources-folders__menu-content">
                                <a href="#"><FolderAddOutlined />{t("resources.menu.add")}</a>
                                <a href="#"><SendOutlined />{t("resources.menu.send")}</a>
                                <a href="#"><ShareAltOutlined />{t("resources.menu.share")}</a>
                            </div>
                        </div>
                    </div>
                </div>;
            })
            }
            </div>
        </>
    )
};

export default MessageTutor;
